<template>
  <!--  <router-link :to="{ name: link, params: params }">-->
  <button class="defaultButton"><slot></slot></button>
  <!--  </router-link>-->
</template>

<script>
export default {
  props: {
    link: String,
    params: {},
  },
}
</script>

<style lang="scss" scoped>
@import '../../design/common-settings';

.defaultButton {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 250px;
  height: 48px;
  margin: 0 auto;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  background-color: $primary-color;
  border-radius: 10px;
  &[disabled] {
    pointer-events: none;
    cursor: not-allowed;
    background-color: $tertiary-color;
  }
}
</style>
